export default __webpack_public_path__ + "static/media/file-zip.3f04eae6.svg";